import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StaffSitesService } from '../../services/staff-sites.service';
import { AssignedWebsite } from '../../models/staff-access.model';

@Component({
  selector: 'app-assigned-websites', standalone: true, imports: [CommonModule],
  template: `
    <div class="page-head"><div><h1>Assigned websites</h1>
      <p>Build and publish websites for your assigned businesses.</p></div>
      <button class="act-ghost" (click)="load()" [disabled]="loading">Refresh</button></div>
    <div class="page-body">
      <p *ngIf="loading" role="status">Loading assigned websites…</p>
      <p *ngIf="error" class="note note-err" role="alert">{{ error }}</p>
      <p *ngIf="!loading && !error && !websites.length">No businesses are assigned to you. Ask an administrator to assign a business.</p>
      <ul class="rows" *ngIf="!loading && !error">
        <li class="panel" *ngFor="let site of websites">
          <h2>{{ site.businessName }}</h2><p>Site status: {{ site.siteStatus || 'Unknown' }}</p>
          <a class="act" [href]="sites.builderUrl(site.businessId)" target="_blank" rel="noopener noreferrer">Open builder</a>
        </li>
      </ul>
    </div>`
})
export class AssignedWebsitesComponent implements OnInit {
  readonly sites = inject(StaffSitesService);
  private readonly destroyRef = inject(DestroyRef);
  websites: AssignedWebsite[] = [];
  loading = false;
  error = '';
  ngOnInit(): void { this.load(); }
  load(): void {
    if (this.loading) return;
    this.loading = true; this.error = ''; this.websites = [];
    this.sites.assigned().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: websites => { this.websites = websites; this.loading = false; },
      error: () => { this.loading = false; this.error = 'Assigned websites could not be loaded. Please retry or contact an administrator.'; }
    });
  }
}
